module.exports = __webpack_public_path__ + "img/cl_feed_img_error.37bc9f3a.png";